import {
  hideProngNumber,
  hideBasketStyle,
  hideCathedralShoulders
} from '../../../../utils/jewelry-validation'

export const validateProngFields = (filters) => {
  let fieldNames = [
    'prong_style'
  ]

  // if prong_number field is not hidden, then it should be validated
  if (!hideProngNumber(filters)) {
    fieldNames.push('prong_number')
  }
  // if basket_style field is not hidden, then it should be validated
  if (!hideBasketStyle(filters)) {
    fieldNames.push('basket_style')
  }
  // if cathedral_shoulders field is not hidden, then it should be validated
  if (!hideCathedralShoulders(filters)) {
    fieldNames.push('cathedral_shoulders')
  }

  return fieldNames.filter((e) => { return filters[e] === null })
}



// WEBPACK FOOTER //
// ./src/containers/jewelry/validations/prong-fields/index.js